import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { registerUser } from "../../../redux/auth/actions";
import { useDispatch } from "react-redux";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import useAuthModalHook from "../../../hooks/useAuthModalHook";
import { getMobileDetails } from "./MobileNumberVerifyModal";
import { AuthModals } from "../../../config/const";

const RegisterModal = ({ show, agentCode: agentCodeProp }) => {
  const { updateActiveAuthModal } = useAuthModalHook();
  const validationMessages = [
    { text: "at least 8 symbols", key: 1 },
    { text: "at least 1 digit (0-9)", key: 2 },
    { text: "at least 1 lowercase characters (a-z)", key: 3 },
    { text: "at least 1 uppercase characters (A-Z)", key: 4 },
  ];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPasswordValidtions, setShowPasswordValidations] = useState(false);
  const [validationIndex, setValidationIndex] = useState([]);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [agentCode, setAgentCode] = useState(agentCodeProp);
  const [isLoading, setIsLoading] = useState(false);

  const checkForPasswordValidations = (e) => {
    const password = e.target.value;
    let fulfilledindex = [];
    if (password.length >= 8) {
      fulfilledindex.push(1);
    }
    if (/\d/.test(password)) {
      fulfilledindex.push(2);
    }
    const smallAlp = new RegExp("(?=.*[a-z])");
    if (smallAlp.test(password)) {
      fulfilledindex.push(3);
    }
    const capAlp = new RegExp("(?=.*[A-Z])");
    if (capAlp.test(password)) {
      fulfilledindex.push(4);
    }
    setValidationIndex(fulfilledindex);
  };

  const validateData = (data = null) => {
    const dataToValidate = data ? data : formData;
    const { username, password, email } = dataToValidate;
    const newErrors = {};

    if (!username || username === "") {
      newErrors.userName = "User name cannot be empty";
    }
    if (username && (username.length < 4 || username.length > 15)) {
      newErrors.userName = "Username must be 4 to 15 characters.";
    }
    if (!/^[A-Za-z0-9 ]+$/.test(username)) {
      newErrors.userName = "Special characters are not allowed in username.";
    }
    if (!password || password === "") {
      newErrors.password = "Password cannot be empty";
    }
    if (password && (password.length < 8 || password.length > 20)) {
      newErrors.password = "Password must be 8 to 20 characters.";
    }

    if (!email || email === "") {
      newErrors.email = "Email cannot be empty";
    }
    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errorsData = validateData();

    if (Object.keys(errorsData).length) {
      return;
    }

    let dataToSend = { ...formData };

    if (agentCode) {
      dataToSend.agent_code = agentCode;
    }

    setIsLoading(true);
    dispatch(
      registerUser(
        {
          ...dataToSend,
          name: formData?.username,
          ...getMobileDetails(),
        },
        () => {
          setIsLoading(false);
        }
      )
    );
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
    validateData(tempFormData);
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas login-register register"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => updateActiveAuthModal(null)}
        closeVariant="black"
      ></Modal.Header>

      <Modal.Body>
        <div className="inner-wrapper">
          <h2 className="title">Register Now</h2>

          <Form onSubmit={handleSubmit}>
            {/* <Form.Group className="form-group" controlId="formBasicPassword">
              <Fprm.Label htmlFor="formBasicName">Enter Name*</Fprm.Label>
              <Form.Control
                type={"text"}
                name="name"
                placeholder="Name*"
                onChange={handleChange}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.name}
              </Form.Control.Feedback>
            </Form.Group> */}
            <Form.Group className="form-group" controlId="formBasicPassword">
              {/* <form.label htmlFor="formBasicName">Enter Uername*</form.label> */}
              <Form.Control
                type="text"
                name="username"
                placeholder="Username*"
                onChange={handleChange}
                isInvalid={!!errors.userName}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.userName}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-group" controlId="formBasicPassword">
              {/* <Form.Label htmlFor="formBasicName">Enter email*</Form.Label> */}
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter email*"
                onChange={handleChange}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors?.email}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-group" controlId="formBasicPassword">
              {/* <Form.Label htmlFor="formBasicName"> Password*</Form.Label> */}
              <Form.Control
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password*"
                autoComplete="new-password"
                onChange={(e) => {
                  handleChange(e);
                  checkForPasswordValidations(e);
                }}
                isInvalid={!!errors.password}
                onFocus={() => {
                  setShowPasswordValidations(true);
                }}
              />
              <span className="icon" onClick={() => setShowPassword((p) => !p)}>
                {showPassword ? <IoIosEyeOff /> : <IoIosEye />}
              </span>
              <Form.Control.Feedback type="invalid">
                {errors?.password}
              </Form.Control.Feedback>
            </Form.Group>

            {showPasswordValidtions && (
              <div className="password-note d-none">
                <ul>
                  {validationMessages.map((item, index) => {
                    const result = validationIndex.find((i) => i === item.key);
                    return (
                      <li className={result ? "pwd-validation-message" : ""}>
                        {item?.text}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}

            <Form.Group className="form-group" controlId="formBasicPassword">
              <Form.Control
                type={"text"}
                name="agent_code"
                className="Agentcode"
                placeholder="Enter Agent/Referral Code"
                value={agentCode}
                onChange={(e) => setAgentCode(e.target.value)}
              />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="btn_primary submit-btn"
              disabled={isLoading}
            >
              {isLoading ? "Loading.." : "Register"}
            </Button>
          </Form>

          <div className="signin-signup">
            Already have an account?{" "}
            <a
              href="#"
              onClick={() => {
                updateActiveAuthModal(AuthModals.Login);
              }}
            >
              Sign In
            </a>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default RegisterModal;
